import { ServiceResponse } from "@se/platform";
const IFBSFeedbackServiceId = Symbol("IFBSFeedbackService");

interface IFBSFeedbackService {
    SubmitFBSFeedbackForm(FeedbackDetails: string, NodeId: number, accessToken:string): Promise<ServiceResponse<string>>;
}
export { IFBSFeedbackServiceId, IFBSFeedbackService }